import { EKycVerificationStatus, type EKycDocumentVerificationStatus } from '@exam-center/graphql';
import { Flex, Image, Label, Text } from '@shared/components';

import { EKYC_DOCUMENT_STATUS_COLOR, EKYC_DOCUMENT_STATUS_TEXT } from '../../constants';
export interface ProctoringEkycFacialVerificationProps {
  slotProps?: {
    image?: {
      idCardImage: string;
      faceImage: string;
    };
    faceMatched?: EKycDocumentVerificationStatus;
    status?: {
      eKycStatus: EKycVerificationStatus;
    };
  };
}

export default function ProctoringEkycFacialVerification(
  props: Readonly<ProctoringEkycFacialVerificationProps>,
) {
  const { slotProps } = props;
  const statusKey = slotProps?.faceMatched as keyof typeof EKYC_DOCUMENT_STATUS_COLOR;
  const labelColor = EKYC_DOCUMENT_STATUS_COLOR[statusKey];

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), width: '100%' })}>
      <Text
        variant='h4'
        sx={(theme) => ({
          borderLeft: `4px solid ${theme.palette.primary.main}`,
          pl: theme.spacing(4),
        })}
      >
        Facial Verification
      </Text>
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text
          variant='body1Semibold'
          sx={{
            maxWidth: '240px',
            width: '100%',
          }}
        >
          ผลการตรวจสอบใบหน้า
        </Text>
        <Label color={labelColor} size='large'>
          {EKYC_DOCUMENT_STATUS_TEXT[statusKey]}
        </Label>
      </Flex>
      {slotProps?.status?.eKycStatus !== EKycVerificationStatus.Rejected &&
      slotProps?.image?.idCardImage &&
      slotProps?.image?.faceImage ? (
        <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
          <Text
            variant='body1Semibold'
            sx={{
              maxWidth: '240px',
              width: '100%',
            }}
          >
            เปรียบเทียบภาพถ่าย
          </Text>
          <Flex sx={(theme) => ({ gap: theme.spacing(4), width: '100%' })}>
            <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(2) })}>
              <Text>ภาพถ่ายหน้าบัตรประชาชน</Text>
              <Image src={slotProps.image.idCardImage} alt='ID Card' sx={{ width: '300px' }} />
            </Flex>
            <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(2) })}>
              <Text>ภาพถ่ายหน้าตรง</Text>
              <Image src={slotProps.image.faceImage} alt='Face' sx={{ width: '300px' }} />
            </Flex>
          </Flex>
        </Flex>
      ) : null}
    </Flex>
  );
}
